import { useSelector } from 'react-redux';
import { NavigationMinisite } from './'
import { Container } from 'semantic-ui-react';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import { useLocation } from 'react-router-dom';


const HeaderMinisite = () => {
  const customRoot = useSelector((state) => state.navroot.data?.custom_root);
  const { pathname } = useLocation();
  const isRoot = flattenToAppURL(customRoot['@id']) === pathname || flattenToAppURL(customRoot['@id']) === '/';

  return (
    <div className="headMinisite" >
      <Container>
        {customRoot?.title && (
          isRoot ? (
            <h1 className='h2 headMinisite__title mb-0'>
              {customRoot.title}
            </h1>
          ) : (
            <p className='h2 headMinisite__title mb-0'>
              <UniversalLink className='headMinisite__title__link' href={flattenToAppURL(customRoot['@id'])}>
                {customRoot.title}
              </UniversalLink>
            </p>
          )
        )}
        <NavigationMinisite />
      </Container>
    </div>
  )
};

export default HeaderMinisite;